import React, { useEffect, useState } from "react";
import BarGraph from "../svg-graphs/BarGraph";
import { getSalesReport } from "../../utils/dataFetch";

export default function SalesReport({ startDate, endDate }) {
    const [error, setError] = useState("");
    const [revenue, setRevenue] = useState([]);
    const [cost, setCost] = useState([]);
    const [income, setIncome] = useState([]);
    const [rci, setRCI] = useState([]);

    useEffect(() => {
        const fetchSalesReport = async () => {
            try {
                const tempStart = new Date(startDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                let salesReport = await getSalesReport(tempStart.toISOString(), tempEnd.toISOString());
                setRevenue(salesReport.revenue);
                setCost(salesReport.cost);
                setIncome(salesReport.income);
                setRCI(salesReport.rci);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };
        fetchSalesReport();
    }, [startDate, endDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Статистика продажів</h5>
                {error && <div className="alert alert-danger rounded-5 m-auto">{error}</div>}
                {!error && (
                    <>
                        {rci.length === 0 && <h5 className="text-center mt-3">Дані відсутні!</h5>}
                        {rci.length > 0 && (
                            <TabPanel
                                tabs={[
                                    {
                                        label: "Виручка",
                                        content: <BarGraph inputData={revenue} legendLabels={["Виручка"]} rowLabel={"Дата"} />,
                                    },
                                    {
                                        label: "Собівартість",
                                        content: <BarGraph inputData={cost} legendLabels={["Собівартість"]} rowLabel={"Дата"} />,
                                    },
                                    {
                                        label: "Дохід",
                                        content: <BarGraph inputData={income} legendLabels={["Дохід"]} rowLabel={"Дата"} />,
                                    },
                                    {
                                        label: "Разом",
                                        content: <BarGraph inputData={rci} legendLabels={["Виручка", "Собівартість", "Дохід"]} rowLabel={"Дата"} />,
                                    },
                                ]}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

const TabPanel = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(tabs[0].label);

    return (
        <>
            {/* tabs */}
            <ul className="nav nav-underline nav-fill">
                {tabs.map((tab) => (
                    <li className="nav-item" key={tab.label}>
                        <button className={`nav-link ${activeTab === tab.label ? "active" : "text-dark"}`} onClick={() => setActiveTab(tab.label)}>
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>

            {/* active tab data */}
            <div className="tab-content mt-4">
                {tabs.map((tab) => (
                    <div key={tab.label} className={`tab-pane fade ${activeTab === tab.label ? "show active" : ""}`}>
                        {tab.content}
                    </div>
                ))}
            </div>
        </>
    );
};
